import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    repository = new IndexRepository()
    
    checkYearChannel = new Subject();
    createPeriodeChannel = new Subject();
    workUnitChannel = new Subject();
    exportExcelChannel = new Subject();
    exportExcelEmpChannel = new Subject();
    downloadLetterChannel = new Subject();

    constructor() {
        this.checkYearChannel.next({status: apiResponse.INITIAL})
        this.createPeriodeChannel.next({status: apiResponse.INITIAL})
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.exportExcelChannel.next({status: apiResponse.INITIAL})
        this.exportExcelEmpChannel.next({status: apiResponse.INITIAL})
        this.downloadLetterChannel.next({status: apiResponse.INITIAL})
    }

    fetchCheckYear = async (query) => {
        try {
            this.checkYearChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckYear(query).then((result) => {
                this.checkYearChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkYearChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchCreatePeriode = async (query) => {
        try {
            this.createPeriodeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreatePeriode(query).then((result) => {
                this.createPeriodeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createPeriodeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchExportExcel = async (query) => {
        try {
            this.exportExcelChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportExcel(query).then((result) => {
                this.exportExcelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportExcelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }
    
    fetchExportExcelEmp = async (query) => {
        try {
            this.exportExcelEmpChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportExcelEmp(query).then((result) => {
                this.exportExcelEmpChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportExcelEmpChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchDownloadLetter = async (query) => {
        try {
            this.downloadLetterChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadLetter(query).then((result) => {
                this.downloadLetterChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadLetterChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }
}

export default IndexBloc